var allData;

try {
    const actions = require('./actions.json');
    const articleMetadata = require('./articleMetadata.json');

    allData = {
        actions,
        articleMetadata,
        useStatic: true
    };
} catch (ex) {
    allData = {
        useStatic: false
    };
}

export default allData;
